import './stats.scss';

/**
 * version    1.0
 * class      <type> (Stats)
 * classdesc  Component that manage Stats component
 */
export class Stats {
  constructor() {
    this.cards = document.querySelectorAll('.js-card');
    this.activePopover = null;

    this.init();
  }

  init() {
    this.cards.forEach((card) => {
      const trigger = card.querySelector('.js-trigger');
      const popover = card.querySelector('.js-popover-stats');
      const closeBtn = card.querySelector('.js-close');

      // apertura
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle(popover, trigger);
      });

      // chiusura con X
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.close(popover, trigger);
      });
    });

    // click fuori = chiude (backdrop logico)
    document.addEventListener('click', () => {
      this.closeAll();
    });
  }

  toggle(popover, trigger) {
    const isOpen = popover.classList.contains('is-open');

    this.closeAll();

    if (!isOpen) {
      popover.classList.add('is-open');
      popover.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      this.activePopover = popover;
    }
  }

  close(popover, trigger) {
    popover.classList.remove('is-open');
    popover.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    this.activePopover = null;
  }

  closeAll() {
    document.querySelectorAll('.js-popover-stats.is-open').forEach((popover) => {
      if (popover) {
        const trigger = popover.closest('.js-card').querySelector('.js-trigger');
        this.close(popover, trigger);
      }
    });
  }
}
